import React from 'react'

function Center() {
  return (

<>
<h2>Center Element</h2>
<p className='p-doc'>center by margin</p>
<code>cen</code>
<br/>
<br/>

<p className='p-doc'>center by flex vertically</p>
<code>cen-flex-v</code>
<br/>
<br/>

<p className='p-doc'>center by flex horizontal</p>
<code>cen-flex-h</code>
<br/>
<br/>
<p className='p-doc'>center by grid vertical</p>
<code>cen-grd-v</code>
<br/>
<br/>

<p className='p-doc'>center by grid horizontal</p>
<code>cen-grd-h</code>
<br/>
<br/> 

<p className='p-doc'>center by absolute position horizontal and vertically</p>
<code>cen-abs</code>

</>
    )
}

export default Center